import { render, staticRenderFns } from "./NotSupportedBrowser.vue?vue&type=template&id=fdf117d4&"
import script from "./NotSupportedBrowser.vue?vue&type=script&lang=js&"
export * from "./NotSupportedBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports